var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChevronUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconChewron"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.79117 7.46845C7.90651 7.3492 8.0935 7.3492 8.20883 7.46845L12.0213 11.4106C12.1367 11.5298 12.3236 11.5298 12.439 11.4106L13.4135 10.4029C13.5288 10.2837 13.5288 10.0903 13.4135 9.97105L8.20883 4.58944C8.0935 4.47019 7.90651 4.47019 7.79117 4.58944L2.5865 9.97105C2.47117 10.0903 2.47117 10.2837 2.5865 10.4029L3.56102 11.4106C3.67635 11.5298 3.86334 11.5298 3.97868 11.4106L7.79117 7.46845Z",
    fill: "#BFCBE0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronUp);
export default __webpack_public_path__ + "static/media/iconChevronUp.f9c4284f3396d39b33238b45ea576eae.svg";
export { ForwardRef as ReactComponent };